/**
 * 环形图统计组件
 * @description 用户班级成绩查看
 * @author xyguo
 * @date 2020-3-11
 */
import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom'
import '@/styles/components/exam/examPreviw/index.less'
import { component_tool } from '@/tool'
let {
    WizComponent,
    WizRow,
    WizCol,
    WizTypography,
    WizBizcharts,
    WizDataSet,
} = component_tool;
let {
    Chart,
    Geom,
    Axis,
    Tooltip,
    Coord,
    Legend,
    Guide,
} = WizBizcharts
const { Title, Text, Paragraph } = WizTypography
export default class ClassResultPercent extends WizComponent {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {
        let { percentProps } = this.props;
        this._renderPercent(percentProps);
        this.innerWidth = window.innerWidth;
        this.autoSize = setInterval(() => {
            if (this.innerWidth != window.innerWidth) {
                this._renderPercent(percentProps);
                this.innerWidth = window.innerWidth
            }
        }, 1000);

    }

    componentWillUnmount() {
        clearInterval(this.autoSize)
    }

    /**
     * 渲染percent
     */
    _renderPercent = ({ data, count, dataFormat, centerText }) => {
      const ds = new WizDataSet();
      const dv = ds.createView().source(data).transform(dataFormat);
      const { Html } = Guide;
        const cols = {
            percent: {
                formatter: val => {
                    val = (val * 100).toFixed(2) + "%";
                    return val;
                }
            }
        };
        let o = document.getElementById("_content");
        let pHeight = o.offsetWidth * 0.18;
        let pWidth = o.offsetWidth * 0.6;
        ReactDOM.render((
            <Chart
                height={pHeight}
                width={pWidth}
                data={dv}
                scale={cols}
                padding={{ top: 20, left: -pWidth * 0.5, bottom: 10 }}
            >
                <Coord type={"theta"} radius={0.75} innerRadius={0.7} />
                <Axis name="percent" />
                <Legend
                    clickable={false}
                    position="right-center"
                    offsetX={-pWidth * 0.5}
                    textStyle={{
                        textAlign: 'start', // 文本对齐方向，可取值为： start middle end
                        fill: 'black', // 文本的颜色
                        fontSize: '12', // 文本大小
                        //fontWeight: 'bold', // 文本粗细
                        textBaseline: 'middle' // 文本基准线，可取 top middle bottom，默认为middle
                    }}
                    itemFormatter={val => {
                        let p = 0;
                        let c = 0;
                        data.forEach(d => {
                            if (d['item'] === val) {
                              if (count == 0){
                                p = '0%';
                              }else{
                                p = (d['count'] * 100 / count).toFixed(2) + "%"
                              }
                                c = d['count']
                            }
                        });
                        return val + '    ' + p + '    ' + c; // val 为每个图例项的文本值
                    }}

                />
                <Tooltip
                    showTitle={false}
                    itemTpl="<li><span style=&quot;background-color:{color};&quot; class=&quot;g2-tooltip-marker&quot;></span>{name}: {value}</li>"
                />
                <Guide>
                    <Html
                        position={["50%", "50%"]}
                        html={() => {
                            return `<div style="text-align:center;font-size:0.8em">${centerText}<br/><span style="color:black;font-size:2em">${count}</span></div>`;
                        }}
                        alignX="middle"
                        alignY="middle"
                    />
                </Guide>
                <Geom
                    type="intervalStack"
                    position="percent"
                    color="item"
                    tooltip={[
                        "item*percent",
                        (item, percent) => {
                            percent = (percent * 100).toFixed(2) + "%";
                            return {
                                name: item,
                                value: percent
                            };
                        }
                    ]}
                    style={{
                        lineWidth: 1,
                        stroke: "#fff"
                    }}
                >
                </Geom>
            </Chart>
        ), document.getElementById('percentView'));
    }


    /**
     * 头部：名称
     */
    _header = ({ title, value, props }) => {
        return (
             <WizRow style={{padding:0,margin:0}}>
              <WizCol span={8}>
                  <Text strong {...props}>
                    {title[0]}：{value[0]}
                 </Text>
              </WizCol>
              <WizCol span={10}>
                  <Text strong {...props}>
                    {title[1]}：{value[1]}
                 </Text>
              </WizCol>
            </WizRow>
        )
    };

    /**
     * 中间部分：统计图表
     */
    _content = () => {
        return (
            <WizRow id={'_content'}  key={new Date().getTime()+'_content'} type={'flex'} align={'middle'}>
                <div id='percentView'></div>
                <div style={{ padding: 20 }}>
                    {this._items()}
                </div>
            </WizRow>
        )
    }

    /**
     * 图标边上的统计项
     */
    _items = () => {
        let { itemProps } = this.props;
        let r = []
        if (!itemProps.length) {
            return r;
        }
        let padding = { style: { padding: 8 } }
        let lessFont = { style: { padding: 8, color: '#66666' } }
        let mainFont = { style: { padding: 8, color: '#3a3a3a' } };
        let count = 0;
        itemProps.forEach(item => {
            if (item['title'] && item['value']) {
              count++;
                let img = item['img'] ? <img src={item['img']} style={{ height: 25, width: 25 }} /> : null;
                r.push(
                    <WizRow {...padding}  key={new Date().getTime()+"_"+count}>
                        <span {...padding}>{img}</span>
                        <span {...lessFont}>{item['title']}</span>
                        <span {...mainFont}>{item['value']}</span>
                    </WizRow>
                )
            }
        });
        return r;
    }

    /**
     * 尾部：其他信息展示
     */
    _footer = (footerView) => {
        return footerView
    }

    render() {
        let { headerProps, footerView } = this.props;
        return (
            <>
                {this._header(headerProps)}
                {this._content()}
                {this._footer(footerView)}
            </>
        )

    }
}

/**
 * 默认值
 */
ClassResultPercent.defaultProps = {
    headerProps: { title: '', value: '', props: {}, centerText: '' },
    percentProps: {
        data: [],
        dataFormat: {},
        count: 0
    },
    itemProps: []

};

/**
 * props入参校验
 */
ClassResultPercent.propTypes = {
    /**
     * title的参数
     */
    headerProps: PropTypes.obj,
    /**
     * percent的参数
     */
    percentProps: PropTypes.obj,
    /**
     * 统计条目内容 [{img,title,value}]
     */
    itemProps: PropTypes.array,
    /**
     * 底部的展示
     */
    footerView: PropTypes.any
};
